import { cn } from "@/shared/lib/cn";

type BadgeVariant = "success" | "warning" | "danger" | "info" | "purple" | "neutral";

const variants: Record<BadgeVariant, string> = {
  success: "bg-green/15 text-green",
  warning: "bg-yellow/15 text-yellow",
  danger: "bg-danger-soft text-danger",
  info: "bg-teal/15 text-teal",
  purple: "bg-purple-soft text-purple",
  neutral: "bg-card-muted text-muted-foreground",
};

type StatusBadgeProps = {
  children: React.ReactNode;
  variant?: BadgeVariant;
  className?: string;
};

export function StatusBadge({ children, variant = "neutral", className }: StatusBadgeProps) {
  return (
    <span
      className={cn(
        "inline-flex items-center rounded-md px-2 py-0.5 text-[11px] font-semibold uppercase tracking-wide",
        variants[variant],
        className
      )}
    >
      {children}
    </span>
  );
}
